(() => {
  'use strict';
  const shell = document.getElementById('sgx-shell');
  let main = document.getElementById('MainContent');
  if (!shell || !main) return;
  let navigating = false;
  let pending = null;
  let modalCheckQueued = false;
  function syncGalleryModal() {
    modalCheckQueued = false;
    const open = Array.from(document.querySelectorAll('.switch-apps-gallery--popup[aria-modal="true"]')).some(popup => {
      const style = getComputedStyle(popup);
      const bounds = popup.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.top < window.innerHeight;
    });
    document.body.classList.toggle('sgx-gallery-modal-open', open);
  }
  function queueGalleryModalCheck() {
    if (modalCheckQueued) return;
    modalCheckQueued = true;
    requestAnimationFrame(syncGalleryModal);
  }
  new MutationObserver(queueGalleryModalCheck).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style', 'aria-modal', 'aria-hidden'], subtree: true });
  queueGalleryModalCheck();

  function permitted(url) {
    if (url.origin !== location.origin) return false;
    if (!['http:', 'https:'].includes(url.protocol)) return false;
    if (/^\/(cart|account|checkout|challenge|apps)(\/|$)/.test(url.pathname)) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    return true;
  }
  function updateDock() {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    const route = path === '/' ? 'home' : path.startsWith('/collections') || path.startsWith('/products') ? 'shop' : path === '/pages/tools' ? 'tools' : path === '/music' || path === '/pages/music' ? 'radio' : path === '/gallery' || path === '/pages/gallery' ? 'gallery' : '';
    shell.querySelectorAll('[data-sgx-route]').forEach(item => {
      item.classList.toggle('is-active', item.dataset.sgxRoute === route);
      if (item.dataset.sgxRoute === route) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  }
  async function navigate(url, push = true) {
    if (navigating) { pending = { url, push }; return; }
    navigating = true;
    try {
      const response = await fetch(url.href, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Navigation failed');
      const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextMain = documentNext.getElementById('MainContent');
      if (!nextMain) throw new Error('Page content missing');
      documentNext.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
        const href = link.getAttribute('href');
        if (!href) return;
        const absolute = new URL(href, url.href).href;
        if (!Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(existing => existing.href === absolute)) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet'; stylesheet.href = absolute;
          document.head.appendChild(stylesheet);
        }
      });
      const performSwap = () => { main.replaceWith(nextMain); main = nextMain; };
      performSwap();
      document.title = documentNext.title;
      if (push) history.pushState({ sgx: true }, '', url.href);
      updateDock();
      window.scrollTo(0, 0);
      nextMain.querySelectorAll('script').forEach(original => {
        const script = document.createElement('script');
        for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
        script.textContent = original.textContent;
        original.replaceWith(script);
      });
      documentNext.head.querySelectorAll('script[src*="/extensions/"]').forEach(original => {
        const absolute = new URL(original.getAttribute('src'), url.href).href;
        if (Array.from(document.scripts).some(existing => existing.src === absolute) && !absolute.includes('customer-gallery-pro')) return;
        const script = document.createElement('script');
        for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
        script.src = absolute;
        document.head.appendChild(script);
      });
      document.dispatchEvent(new CustomEvent('sgx:page-ready', { detail: { url: url.href } }));
      queueGalleryModalCheck();
    } catch (error) {
      console.warn('Slot Grill navigation fell back to page load:', error);
      location.assign(url.href);
    } finally {
      navigating = false;
      if (pending) {
        const next = pending;
        pending = null;
        navigate(next.url, next.push);
      }
    }
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.target || anchor.hasAttribute('download') || anchor.getAttribute('href').startsWith('#') || anchor.closest('[data-no-sgx-navigation]')) return;
    const url = new URL(anchor.href, location.href);
    if (!permitted(url)) return;
    event.preventDefault();
    navigate(url);
  });
  window.addEventListener('popstate', () => navigate(new URL(location.href), false));
})();
